import {
  AdditionalGroupProps,
  translatedAdditionalGroupProps,
} from 'modules/additional-groups/types';
import {TranslatedKeys} from 'shared/types/translated-keys';

export interface AdditionalProps {
  id: string;
  name: string;
  description?: string;
  active: boolean;
  additionalGroupId: string;
  additionalGroup: AdditionalGroupProps;
  price: number;
  image?: string;
}

export const translatedAdditionalProps: TranslatedKeys<AdditionalProps> = {
  name: 'Nome',
  description: 'Descrição',
  active: 'Ativo?',
  additionalGroupId: 'Grupo de adicionais',
  additionalGroup: {
    ...translatedAdditionalGroupProps,
    name: 'Grupo de adicionais',
  },
  price: 'Preço',
  image: 'Imagem',
};
